import React, { ReactNode } from 'react';
import Styles from "./H1.module.scss";

export const H1 = (
	{
		children
	}: {
		children: ReactNode
	}
) => {
	return (
		<h1 className={Styles.h1}>
			{children}
		</h1>
	);
};

export default H1;
